/* POCKET KEYSTONE — scripts propios (sin librerías) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.lm-reveal:not(.lm-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('lm-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('lm-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initCifras() {
    var els = document.querySelectorAll('[data-lm-cifra]:not([data-lm-hecha])');
    if (!els.length) return;
    function animar(el) {
      el.setAttribute('data-lm-hecha', '1');
      var fin = parseInt(el.getAttribute('data-lm-cifra'), 10);
      if (isNaN(fin) || reduce) return;
      var dur = 1400, t0 = null;
      function paso(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        el.textContent = Math.round(fin * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(paso);
      }
      el.textContent = '0';
      requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { animar(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initGaleria() {
    document.querySelectorAll('[data-lm-galeria]').forEach(function (gal) {
      var principal = gal.querySelector('[data-lm-principal]');
      if (!principal) return;
      gal.querySelectorAll('[data-lm-mini]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          principal.style.opacity = '0';
          setTimeout(function () {
            principal.src = btn.getAttribute('data-src');
            principal.srcset = btn.getAttribute('data-srcset') || '';
            principal.alt = btn.getAttribute('data-alt') || '';
            principal.style.opacity = '1';
          }, 150);
          gal.querySelectorAll('[data-lm-mini]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
          btn.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  function initCantidad() {
    document.querySelectorAll('[data-lm-cantidad]').forEach(function (w) {
      var input = w.querySelector('input');
      w.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          v += b.getAttribute('data-paso') === '-1' ? -1 : 1;
          input.value = Math.max(1, v);
        });
      });
    });
  }

  function initVariantes() {
    document.querySelectorAll('[data-lm-producto]').forEach(function (root) {
      var json = root.querySelector('[data-lm-variantes]');
      if (!json) return;
      var variantes = JSON.parse(json.textContent);
      var idInput = root.querySelector('input[name="id"]');
      var btn = root.querySelector('[data-lm-boton]');
      var precio = root.querySelector('[data-lm-precio]');
      var antes = root.querySelector('[data-lm-antes]');
      var textoBoton = btn ? btn.getAttribute('data-texto') : '';
      var textoAgotado = btn ? btn.getAttribute('data-agotado') : '';
      var formato = root.getAttribute('data-lm-moneda') || '{{amount_with_comma_separator}} €';
      function dinero(c) {
        var n = (c / 100).toFixed(2);
        return formato.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.replace('.', ','))
                      .replace(/\{\{\s*amount\s*\}\}/, n);
      }
      root.addEventListener('change', function (e) {
        if (!e.target.matches('[data-lm-opcion]')) return;
        var sel = [];
        root.querySelectorAll('fieldset[data-lm-fieldset]').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          sel.push(c ? c.value : null);
        });
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return o === sel[i]; });
        });
        if (!v) return;
        idInput.value = v.id;
        if (precio) precio.textContent = dinero(v.price);
        if (antes) {
          if (v.compare_at_price && v.compare_at_price > v.price) { antes.textContent = dinero(v.compare_at_price); antes.hidden = false; }
          else antes.hidden = true;
        }
        if (btn) {
          btn.disabled = !v.available;
          btn.querySelector('span').textContent = v.available ? textoBoton : textoAgotado;
        }
      });
    });
  }

  function initBarra() {
    var barra = document.querySelector('[data-lm-barra]');
    var objetivo = document.querySelector('[data-lm-boton]');
    if (!barra || !objetivo || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var pasado = !e.isIntersecting && e.boundingClientRect.top < 0;
        barra.classList.toggle('lm-barra--on', pasado);
      });
    });
    io.observe(objetivo);
    var b = barra.querySelector('button');
    if (b) b.addEventListener('click', function () {
      var form = objetivo.closest('form');
      if (form) { if (form.requestSubmit) form.requestSubmit(objetivo); else objetivo.click(); }
    });
  }

  function init() {
    initReveal(); initCifras(); initGaleria(); initCantidad(); initVariantes(); initBarra();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function () { initReveal(); initCifras(); initGaleria(); initCantidad(); initVariantes(); });
})();
